import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@verlo/shared/lib/utils"

// A tag says what something is; it never changes on hover (Back office sweep, Oct 2026: a
// "Completed" tag turned navy under the pointer, its green text unreadable). An action that
// looks like a tag is a quiet button instead.
const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
